import React, { useRef, useState } from "react";
import "./index.css";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import PlantInformation from "../pages/plantPage/plantInformation";
import ReplacementResult from "../pages/replacementAdvisorPages/replacementResult";
import { useSelector } from "react-redux";
import Settings from "../pages/home/Settings";
import ReplacementThreshold from "../pages/replacementAdvisorPages/replacementThreshold";

const raXLSFileUpload = React.forwardRef((props, ref) => {
  const {
    activeStep,
    setActiveStep,
    isBackClicked,
    isNextClicked,
    setDisableNextButton,
  } = props;
  const [file_id, setFileId] = useState(useSelector((state) => state.file_id));
  const [noThresholdError, setNoThresholdError] = useState(true);
  const [mandatoryThresholdFilled, setMandatoryThresholdFilled] =
    useState(true);
  const [detailsResult, setDetailsResult] = useState(null);

  const fileRef = useRef(null);
  const plantRef = useRef(null);
  const settingsRef = useRef(null);
  const thresholdRef = useRef(null);

  const onNextClicked = async () => {
    setDetailsResult(false);
    if (noThresholdError) {
      if (settingsRef && settingsRef.current) {
        settingsRef.current.settingsInformation();
      }
      if (fileRef && fileRef.current) {
        fileRef.current.performanceData();
      }
      if (thresholdRef && thresholdRef.current) {
        thresholdRef.current.replacementThreshold();
      }
      if (plantRef && plantRef.current) {
        plantRef.current.plantInformation();
      }
    }
  };

  React.useImperativeHandle(ref, () => ({ onNextClicked }));

  return (
    <div>
      {activeStep === 0 && (
        <div className="uploadContainer">
          <PlantInformation
            ref={plantRef}
            setActiveStep={setActiveStep}
            setDetailsResult={setDetailsResult}
            mandatoryThresholdFilled={mandatoryThresholdFilled}
            ra="ra"
          />
          <Settings
            ref={settingsRef}
            fileId={file_id}
            isBackClicked={isBackClicked}
            disabled={true}
          />
          <ReplacementThreshold
            ref={thresholdRef}
            setNoThresholdError={setNoThresholdError}
            setActiveStep={setActiveStep}
            setMandatoryThresholdFilled={setMandatoryThresholdFilled}
            isNextClicked={isNextClicked}
          />
        </div>
      )}
      {activeStep === 1 && (
        <ReplacementResult
          detailsResult={detailsResult}
          setDisableNextButton={setDisableNextButton}
          previousForecastWindow={props.previousForecastWindow}
          previousPredictionResult={props.previousPredictionResult}
        />
      )}
    </div>
  );
});

export default raXLSFileUpload;
